/**
 * Copyright 2024-2025, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const DECISION_NOTIFICATION_TYPES = {
    AB_TEST: 'ab-test',
    FEATURE: 'feature',
    FEATURE_TEST: 'feature-test',
    FEATURE_VARIABLE: 'feature-variable',
    ALL_FEATURE_VARIABLES: 'all-feature-variables',
    FLAG: 'flag',
};
export const NOTIFICATION_TYPES = {
    ACTIVATE: 'ACTIVATE',
    DECISION: 'DECISION',
    LOG_EVENT: 'LOG_EVENT',
    OPTIMIZELY_CONFIG_UPDATE: 'OPTIMIZELY_CONFIG_UPDATE',
    TRACK: 'TRACK',
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=type.js.map